// components/ActionButtons.js
import React from 'react';
import styled from 'styled-components';
import { cores } from '../../../styles/styleUtils';

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: auto;
`;

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const ConfirmButton = styled(Button)`
  background-color: ${cores.laranja};
  color: white;
  border: none;

  &:hover {
    background-color: ${cores.laranjaEscuro};
  }

  // Estilo para quando o botão estiver desabilitado
  &:disabled {
    background-color: #cccccc; /* Cinza */
    color: #666666; /* Cor do texto mais escura para contraste */
    cursor: not-allowed; /* Altera o cursor para indicar que não é clicável */
  }
`;

const CancelButton = styled(Button)`
  background-color: #dc3545; /* Red */
  color: white;
  border: none;

  &:hover {
    background-color: #c82333;
  }
`;

function ActionButtons({ onConfirm, onCancel, disableConfirm }) {
  return (
    <ButtonContainer>
      <ConfirmButton onClick={onConfirm} disabled={disableConfirm}>Confirmar</ConfirmButton>
      <CancelButton onClick={onCancel}>Cancelar</CancelButton>
    </ButtonContainer>
  );
}

export default ActionButtons;